<script>
  import { onMount } from 'svelte';
  import { writable } from 'svelte/store';

  export let minHeight = '2rem';

  let container;
  let observer;

  const isVisible = writable(false);

  onMount(() => {
    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          isVisible.set(true);
          observer.disconnect(); // Stop observing after first visibility
        }
      },
      { threshold: 0.1 }
    );

    if (container) observer.observe(container);

    return () => observer?.disconnect();
  });
</script>

<div bind:this={container} style="min-height: {minHeight};">
  {#if $isVisible}
    <slot />
  {/if}
</div>
